if (!customElements.get('launch-offer-countdown')) {
  class LaunchOfferCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = new Date(this.dataset.end).getTime();
      this.expiredBehavior = this.dataset.expiredBehavior || 'hide';

      if (Number.isNaN(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');

      this.update();
      this.timer = window.setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        window.clearInterval(this.timer);
      }
    }

    format(value) {
      return String(Math.max(0, value)).padStart(2, '0');
    }

    update() {
      const distance = this.endTime - Date.now();

      if (distance <= 0) {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }

        if (this.expiredBehavior === 'hide') {
          this.hidden = true;
          return;
        }

        this.render(0, 0, 0, 0);
        return;
      }

      const days = Math.floor(distance / 86400000);
      const hours = Math.floor((distance % 86400000) / 3600000);
      const minutes = Math.floor((distance % 3600000) / 60000);
      const seconds = Math.floor((distance % 60000) / 1000);

      this.render(days, hours, minutes, seconds);
    }

    render(days, hours, minutes, seconds) {
      if (this.daysEl) this.daysEl.textContent = this.format(days);
      if (this.hoursEl) this.hoursEl.textContent = this.format(hours);
      if (this.minutesEl) this.minutesEl.textContent = this.format(minutes);
      if (this.secondsEl) this.secondsEl.textContent = this.format(seconds);
    }
  }

  customElements.define('launch-offer-countdown', LaunchOfferCountdown);
}
